<!-- Appointment -->
<template>
  <div class="mentee-appointment">
    <div class="mentee-appointment-item">
      <h1>Appointment - Processing</h1>
      <ul class="mentee-appointment-processing"
          v-if="unfinishList && unfinishList.length>0">
        <li class="mentee-activities-list"
            v-for="(item,index) in unfinishList"
            :key="index">
          <zlr-card-service :title=" item.module| filterMdule"
                            style="width: 400px;"
                            :kind="item.module | todaMap"
                            kind-color="#FFADD2"
                            :explainList="item.backLogs | filterExplainList"
                            circle="warning"
                            @click="linkHandle(item)">
            <div v-if="item.mentorResultTimeStr">{{item.mentorResultTimeStr}} {{item.mentorZone|filterZone}}</div>
          </zlr-card-service>
        </li>
      </ul>
      <zlr-empty v-else></zlr-empty>
    </div>
    <div class="mentee-appointment-item">
      <h1>Appointment - Complete</h1>
      <ul class="mentee-appointment-complete"
          v-if="finishList&& finishList.length>0">
        <li v-for="(item,index) in finishList"
            :key="index">
          <div>
            <span>{{item.module | filterTitle}}</span>
            <span>{{item.module | filterMdule}}</span>
            <span @click="linkHandle(item)"
                  :class="{blue: item.statu !== 'SYSTEM_RECALL' && item.statu !== 'RECALL'}">{{item | filterStatus}}</span>
          </div>
        </li>
        <!-- <li>
          <div>
            <span>Foundation</span>
            <span>Module 1-3, Kick off and Brainstorm</span>
            <span>CD withdrew</span>
          </div>
        </li>
        <li>
          <div>
            <span>Foundation</span>
            <span>Module 1-3, Kick off and Brainstorm</span>
            <span class="blue">CD withdrew</span>
          </div>
        </li> -->
      </ul>
      <zlr-empty v-else></zlr-empty>
    </div>
  </div>
</template>

<script>
// api
import { getAppUnfinishList, getAppFinishList } from '@/api/appointment'
import { getMenteeDetail } from '@/api/mentee'
// components
import ZlrCardService from '_c/card-service/card-service'
import ZlrEmpty from '_c/empty/empty'
// constant
import { moduleMap } from '@/constant'
import { zone } from '@/constant/mentor'
let thats = this
export default {
  name: 'mentee-appointment',
  components: {
    ZlrCardService,
    ZlrEmpty
  },
  data () {
    return {
      num: this.$route.params.id,
      unfinishList: [],
      finishList: [],
      packageId: ''
    }
  },
  computed: {},
  beforeCreate () {
    thats = this
  },
  created () {
    // 获取信息
    this.getMenteeDetail()
  },
  mounted () {
    this.getAppUnfinishList()
    this.getAppFinishList()
  },
  methods: {
    getMenteeDetail () {
      let param = {
        num: this.$route.params.id
      }
      getMenteeDetail(param).then(res => {
        if (res.code === 0) {
          if (res.data.model) {
            this.packageId = res.data.model.packageId
          }
        }
      }).catch(error => {
        this.$zlr_message(error.message, 'error')
      })
    },
    getAppUnfinishList () {
      getAppUnfinishList({
        menteeNum: this.num
      }).then(res => {
        this.unfinishList = res.data.model
      })
    },
    getAppFinishList () {
      getAppFinishList({
        menteeNum: this.num
      }).then(res => {
        this.finishList = res.data.model
      })
    },
    linkHandle (item) {
      this.$router.push({
        name: 'mentee-zoom',
        query: {
          id: item.id
        }
      })
    }
  },
  filters: {
    // 模块对应的 显示文字
    filterMdule (value) {
      if (((thats.packageId === 120) || (thats.packageId === 121)) && value === 'MODULE_1') {
        return 'PS Brainstorming'
      } else {
        return (moduleMap.filter(item => item.value === value))[0]['title']
      }
    },
    // 待办事项
    filterExplainList (list) {
      if (!list) return []
      let arr = []
      list.forEach(item => {
        arr.push({
          title: item.content,
          color: '#85A5FF'
        })
      })
      return arr
    },
    // 时区映射
    filterZone (value) {
      let title = (zone.filter(item => item.value === value))[0]['title']
      return `(${title})`
    },
    // 已完成的title
    filterTitle (module) {
      let title = ''
      switch (module) {
        case 'MODULE_1':
        case 'MODULE_2':
        case 'MODULE_3':
          title = 'Foundation'
          break
        case 'MODULE_7':
        case 'MODULE_8':
          title = 'Comprehensive Support'
          break
      }
      return title
    },
    // 状态
    filterStatus (item) {
      let title = ''
      let statu = item.item
      if (statu === 'SYSTEM_RECALL') {
        title = 'Automatically shut down'
      } else if (statu === 'RECALL') {
        title = 'CD withdrew'
      } else {
        title = `Time spent ${item.timeSpent || 0}mins`
      }
      return title
    }
  }
}
</script>
<style lang='less' scoped>
</style>
